import React, { useState, useEffect } from 'react';
import { CategoryDTO, getCategories } from './CategoryService';


const CategoriesBooking: React.FC = () => {
  const [categories, setCategories] = useState<CategoryDTO[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const apiUrl = process.env.REACT_APP_API_URL ?? "";

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await getCategories(apiUrl);
        if (response.success) {
          setCategories(response.data);
        } else {
          setError(response.message ?? "Failed to fetch categories");
        }
      } catch (error: any) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, [apiUrl]);

  if (loading) {
    return <p>Loading...</p>;
  }
  if (error) {
    return <p>{error}</p>;
  }

  return (
    <section className='tour_packages__booking_section'>
      {categories.map(category => (
        <div className='tour_packages__booking' key={category.id}>
          <h2>{category.name}</h2>
          {category.packages.map(pkg => (
            <div key={pkg.id} className='tour_packages__booking__package'>
              <div
                className='tour_packages__booking__package__header'
                style={{ backgroundImage: `url(${pkg.imageUrls.find(img => img.isMain)?.url || pkg.imageUrls[0]?.url})` }}
              >
                  <h2>{category.name}</h2>
                <h4>{pkg.name}</h4>
              </div>
              <p>{pkg.description}</p>
              <p>Price From: {pkg.priceFrom}</p>
              <p>Max Group Size: {pkg.maxGroupSize}</p>
              {pkg.prices.length > 0 && (
                <div>
                  <h5>Pricing Options:</h5>
                  {pkg.prices.map(price => (
                    <div key={price.id}>
                      <p>Description: {price.description}</p>
                    
                      {price.discount && <p>Discount: {price.discount}</p>}
                  <div>
                    <h5>Date Ranges:</h5>
                    {price.dateRanges.map((dateRange, index) => (
                      <p key={index}>{dateRange.startDate} - {dateRange.endDate}</p>
                    ))}
                  </div>
                      <p>Price: {price.price}</p>
                      <p>Min Persons: {price.minPersons}</p>
                      <p>Max Persons: {price.maxPersons}</p>
                      <p>Booked Persons: {price.bookedPersons}</p>
                      {price.chaletCapacity && <p>Chalet Capacity: {price.chaletCapacity}</p>}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      ))}
    </section>
  );
};

export default CategoriesBooking;